var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetadata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17V15H19V17H21Z",
    fill: "#00a4ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25V19H19V25H21Z",
    fill: "#00a4ec"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C10 14.48 14.48 10 20 10C25.52 10 30 14.48 30 20C30 25.52 25.52 30 20 30C14.48 30 10 25.52 10 20ZM12 20C12 24.41 15.59 28 20 28C24.41 28 28 24.41 28 20C28 15.59 24.41 12 20 12C15.59 12 12 15.59 12 20Z",
    fill: "#00a4ec"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadata);
export default __webpack_public_path__ + "static/media/Metadata.09578c5377eb0295267e6cc7f5030cf1.svg";
export { ForwardRef as ReactComponent };